export const OPTION_CHAIN = "OPTION_CHAIN";
export const OPTION_CHAIN_STREAM = "OPTION_CHAIN_STREAM";
export const OPTION_CHAIN_ERROR = "OPTION_CHAIN_ERROR";
export const OPTION_CHAIN_HIDE_ERROR = "OPTION_CHAIN_HIDE_ERROR";
export const OPTION_CHAIN_START_LOADER = "OPTION_CHAIN_START_LOADER";
export const OPTION_CHAIN_STOP_LOADER = "OPTION_CHAIN_STOP_LOADER";
export const OPTION_CHAIN_EXPIRY_DATE_DATA = "OPTION_CHAIN_EXPIRY_DATE_DATA";
